import React, { useRef, useEffect } from 'react';
import { TextV2 } from '@withjoy/joykit';
import { StyledContainer, Wrapper, StyledInput, Mirror } from './AutoGrowInput.styles';

interface AutoGrowInputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export const AutoGrowInput: React.FC<AutoGrowInputProps> = props => {
  const mirrorRef = useRef<HTMLSpanElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (mirrorRef.current && inputRef.current) {
      mirrorRef.current.textContent = (props.value as string) || ' ';
      const mirrorWidth = mirrorRef.current.offsetWidth;
      inputRef.current.style.width = `${mirrorWidth}px`;
    }
  }, [props.value]);

  return (
    <Wrapper>
      <StyledInput
        onChange={props.onChange}
        ref={inputRef}
        {...props}
      />
      <Mirror ref={mirrorRef} />
    </Wrapper>
  );
};

export const CurrencyInput = ({ currency, hasError, inputProps }: { currency: string; hasError?: boolean; inputProps?: AutoGrowInputProps }) => {
  return (
    <StyledContainer hasError={hasError}>
      <TextV2>{currency}</TextV2>
      <AutoGrowInput {...inputProps} />
    </StyledContainer>
  );
};
